import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestServiceOrderAttendant from './ServiceRequestServiceOrderAttendant'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'view-support-call',
    name:
      'serviceRequestServiceOrderAttendant',
    component: ServiceRequestServiceOrderAttendant,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
